module.exports = __webpack_public_path__ + "static/the-road-to-wigan-pier-c735b15a91a73917c8b10d38d7d511e6.jpg";